import Panel from '../reusable/Panel';
import { AudienceSurveyStats } from '../../services/surveyService';
import { calculateResponseRate, getResponseRateColor } from './utils';
import ResponseRateBox from './ResponseRateBox';
import SchoolResponseTable from './SchoolResponseTable';
import './AudiencePanel.css';

interface AudiencePanelProps {
  title: string;
  audienceStats: AudienceSurveyStats;
  selectedSchoolId: string | null;
  countLabel: string;
  responseRateLabel: string;
}

const AudiencePanel = ({
  title,
  audienceStats,
  selectedSchoolId,
  countLabel,
  responseRateLabel,
}: AudiencePanelProps) => {
  let displayExpected: number | null;
  let displaySubmissions: number;

  if (selectedSchoolId) {
    const schoolData = audienceStats.per_school.find((s) => s.school_id === selectedSchoolId);
    displayExpected = schoolData?.expected_count ?? null;
    displaySubmissions = schoolData?.submission_count ?? 0;
  } else {
    displayExpected = audienceStats.total_expected;
    displaySubmissions = audienceStats.total_submissions;
  }

  const rate = calculateResponseRate(displaySubmissions, displayExpected);
  const color = getResponseRateColor(rate);

  return (
    <Panel className="audience-panel">
      <h2 className="audience-panel-title">{title}</h2>
      <p className="audience-panel-counts">
        <span className="audience-panel-number">{displayExpected !== null ? displayExpected : '—'}</span>{' '}
        <span>{countLabel}</span> <span className="audience-panel-number">{displaySubmissions}</span>{' '}
        <span>responses</span>
      </p>
      <ResponseRateBox rate={rate} label={responseRateLabel} color={color} />
      {!selectedSchoolId && <SchoolResponseTable schools={audienceStats.per_school} />}
    </Panel>
  );
};

export default AudiencePanel;
